import { useQuery } from "react-query";
import {
  ConciliacaoBancariaResponse,
} from "../typings";
import { AxiosError } from "axios";
import  http  from 'infra/http';
import { ListarConciliacaoBancariaQuery } from '../typings/index';

function useConciliacaoBancaria(query: ListarConciliacaoBancariaQuery) {
  return useQuery<ConciliacaoBancariaResponse, AxiosError>(
    [`/v1/extrato-bancario`, query],
    async () => {
      const {data} = await http.get<ConciliacaoBancariaResponse>('/v1/extrato-bancario', {
        params: query
      })

      return data;
    }
  );
}

export default useConciliacaoBancaria;
